import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {User} from '@models/user/user';
import {BrandingService} from '@services/administration/organization/configuration/branding/branding.service';
import {FirebaseAuthenticationService} from '@services/firebase/auth/firebase-authentication.service';
import {AuthenticationRedirectService} from '@services/user/authentication-redirect.service';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'scitis-saml-login',
    templateUrl: './saml-login.component.html',
    styleUrls: ['./saml-login.component.scss'],
    standalone: false
})
export class SamlLoginComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(private loadingIndicator: LoadingIndicatorService,
              private router: Router,
              private brandingService: BrandingService,
              private firebaseAuthenticationService: FirebaseAuthenticationService,
              private authenticationRedirectService: AuthenticationRedirectService
  ) {
  }

  ngOnInit(): void {
    this.getUserDetails();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  getUserDetails() {
    this.loadingIndicator.show();
    this.firebaseAuthenticationService.getLoggedUserDetails()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((userDetails: User) => {
        this.loadingIndicator.hide();
        this.brandingService.applyOrganizationStyles(userDetails.parentId, true);
        if (userDetails.agreementAccepted) {
          const externalRedirect = this.authenticationRedirectService.consumeExternalRedirect();
          if (externalRedirect) {
            this.authenticationRedirectService.clearReturnUrl();
            this.authenticationRedirectService.navigateToExternalRedirect(externalRedirect);
            return;
          }
          const returnUrl = this.authenticationRedirectService.consumeReturnUrl();
          if (returnUrl) {
            this.router.navigateByUrl(returnUrl);
          } else {
            this.router.navigate(['dashboard']);
          }
        } else {
          this.authenticationRedirectService.clearExternalRedirect();
          this.authenticationRedirectService.clearReturnUrl();
          this.router.navigate(['agreement']);
        }
      }, () => {
        this.handleUserDetailsGetError();
      });
  }

  handleUserDetailsGetError() {
    this.firebaseAuthenticationService.samlLogin()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: HttpResponse<any>) => {
          console.log('got saml url', response);
          window.location.href = response.url || '';
        }, (error: HttpResponse<any>) => {
          console.log('error getting saml url', error);
        }
      );
  }
}
